import { render, staticRenderFns } from "./AIChatWidgetTemplateSlider.vue?vue&type=template&id=d6667e04&scoped=true"
import script from "./AIChatWidgetTemplateSlider.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetTemplateSlider.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetTemplateSlider.vue?vue&type=style&index=0&id=d6667e04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6667e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6667e04')) {
      api.createRecord('d6667e04', component.options)
    } else {
      api.reload('d6667e04', component.options)
    }
    module.hot.accept("./AIChatWidgetTemplateSlider.vue?vue&type=template&id=d6667e04&scoped=true", function () {
      api.rerender('d6667e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetTemplateSlider.vue"
export default component.exports